export default __webpack_public_path__ + "static/media/homeBanner.62393121.jpg";